// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__2jmYJ","message":"Loading_message__32l7I","pulse":"Loading_pulse__18G-K"};